<template>
<div>
    <b-table 
      striped 
      hover 
      selectable 
      select-mode="single" 
      @row-selected="onRowSelected" 
      :items="items" 
      :fields="fields" 
      :filter="filter"
      @filtered="onFiltered"
      :per-page="perPage"
      :current-page="currentPage">
      <template v-slot:cell(validity)="data">
        {{ formatValidity(data.item) }}
      </template>
    </b-table>

    <TablePagination 
      :total-rows="totalRows" 
      :per-page="perPage" 
      @pageChange="onPageChange">
    </TablePagination>
</div>
</template>

<script>

import TablePagination from '@/components/Misc/TablePagination'
import timetable from '@/store/timetable/timetable'
import timeUtils from '@/util/timeUtils.js'

export default {
  components: { TablePagination },
  props: ['filter'],
  data() {
      return {
        perPage: 10,
        currentPage: 1,
        filteredRows: 0,
        fields: [
          { key: "id", label: this.$t('season.id') },
          { key: "validity", label: this.$t('season.validity') },
          { key: "explanation", label: this.$t('season.explanation') }          
        ]
      }
  },
  computed: {
    items() {
      return this.$store.state.timetable.seasons.list;
    },
    totalRows() {
        if( this.filteredRows ) 
          return this.filteredRows
        return this.items ? this.items.length : 0
    }               
  },
  created() {
    if (!this.$store.state.timetable) {
      this.$store.registerModule("timetable" , timetable);
    }
    this.$store.dispatch('timetable/getSeasonList');
  },
  methods: {
    onRowSelected(items) {
      this.$emit('selectItem', items[0]);
    },
    onFiltered(filteredItems) {
      this.filteredRows = filteredItems.length;
      this.currentPage = 1
    },
    onPageChange(page){
      this.currentPage = page
    },
    formatValidity(item) {
      const startTime = timeUtils.formattedOrEmpty(item?.startTime , "DD.MM.YYYY")
      const endTime = timeUtils.formattedOrEmpty(item?.endTime, "DD.MM.YYYY")
      return startTime + " - " + endTime
    }
  }
}
</script>
